import React, { useMemo, useState } from "react";
import Stack from "react-bootstrap/Stack";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCirclePlus,
  faArrowRotateRight,
  faFileContract,
} from "@fortawesome/free-solid-svg-icons";
import { useCookies } from "react-cookie";
// Components
import Message from "../../utils/modals/Message";
import DataTable from "../../dynamic-components/DataTable";
import SearchBar from "../../dynamic-components/SearchBar";
import ConfirmModal from "../../dynamic-components/ConfirmModal";
import { changeUserStatusSetData } from "../../../context/api/user/un-block-user/changeUserStatusSetData";

const UsersTable = ({
  lang,
  loader,
  activeCard,
  tableData,
  setCreateUserModal,
  setRefreshData,
}) => {
  const dataTranslate = require(`../../../translate/${
    lang === "AR" ? "arabic" : "english"
  }/data.json`);

  const initialConfirmModal = {
    isShow: false,
    blocked: false,
    rowData: {},
  };
  const initialSuccessMessage = {
    success: false,
    type: "",
    data: {},
  };

  const initialMessageRes = {
    success: Boolean,
    message: String,
    isShow: false,
  };

  const block_action = {
    title: dataTranslate.popups.block_user.block_user,
    submit: dataTranslate.popups.block_user.block,
  };

  const unblock_action = {
    title: dataTranslate.popups.block_user.unblock_user,
    submit: dataTranslate.popups.block_user.unblock,
  };

  const [cookies] = useCookies();
  const [confirmModal, setConfirmModal] = useState(initialConfirmModal);
  const [confirmBtnLoader, setConfirmBtnLoader] = useState(false);
  const [messageResponse, setMessageResponse] = useState(initialMessageRes);
  const [successMessage, setSuccessMessage] = useState(initialSuccessMessage);

  const searchByData = dataTranslate.pages.office_p.table.table_head.search_by;

  const [search, setSearch] = useState({
    type: "id",
    value: "",
  });

  const handleSearch = (e) => {
    const value = e.target.value || undefined;
    setSearch((prev) => ({ ...prev, value: value }));
  };

  const searchOptions = [
    { key: "id", value: searchByData.id },
    { key: "firstName", value: searchByData.name },
    { key: "email", value: searchByData.email },
  ];
  const columns = useMemo(
    () => [
      {
        Header: dataTranslate.pages.office_p.table.table_body.id,
        accessor: "id",
      },
      {
        Header: dataTranslate.pages.office_p.table.table_body.full_name,
        accessor: "firstName",
        Cell: ({ cell }) => {
          return (
            <div>{`${cell.row.original.firstName} ${cell.row.original.secondName}`}</div>
          );
        },
      },

      {
        Header: dataTranslate.pages.office_p.table.table_body.role,
        accessor: "role",
      },

      {
        Header: dataTranslate.pages.office_p.table.table_body.email,
        accessor: "email",
      },

      {
        Header: dataTranslate.pages.office_p.table.table_body.createdAt_date,
        Cell: ({ cell }) => {
          return <div>{cell.row.original.register_date.split("T")[0]}</div>;
        },
      },

      {
        Header: dataTranslate.pages.office_p.table.table_body.action,
        Cell: ({ cell }) => {
          return (
            <div className="d-flex flex-row gap-3 align-content-center justify-content-center">
              <button
                className="office_p-table-table-body-btn"
                style={
                  cell.row.original.isBlocked
                    ? { width: "100px" }
                    : { backgroundColor: "red", width: "100px" }
                }
                onClick={() =>
                  setConfirmModal((prev) => ({
                    ...prev,
                    isShow: true,
                    blocked: cell.row.original.isBlocked,
                    rowData: cell.row.original,
                  }))
                }
              >
                {cell.row.original.isBlocked
                  ? dataTranslate.pages.office_p.table.table_body.unblock
                  : dataTranslate.pages.office_p.table.table_body.block}
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  const changeUserStatus = async (id) => {
    const userId = id;
    const action = confirmModal.blocked ? "unblock" : "block";

    const credintial = {
      action: action,
      employee_id: userId,
    };
    setConfirmBtnLoader(() => true);
    await changeUserStatusSetData(
      lang,
      setMessageResponse,
      cookies,
      credintial,
      setSuccessMessage
    );
    setConfirmBtnLoader(() => false);
  };

  return (
    <>
      <Message
        messageResponse={messageResponse}
        close={() => setMessageResponse(initialMessageRes)}
        lang={lang}
      />
      <div className="office_p-table w-100 d-flex flex-column align-items-center">
        <div className="office_p-table-nav w-100 m-3 px-3">
          <Stack direction="horizontal" gap={3}>
            <div
              className="office_p-table-nav-btn"
              onClick={() =>
                setCreateUserModal((prev) => ({
                  ...prev,
                  isShow: true,
                }))
              }
            >
              <span>{dataTranslate.pages.office_p.table.table_head.add}</span>
              <FontAwesomeIcon
                icon={faCirclePlus}
                size="xl"
                style={{ color: "#f2ce00" }}
              />
            </div>

            {/* <div className="office_p-table-nav-btn">
            <span>{dataTranslate.pages.office_p.table.table_head.report}</span>
            <FontAwesomeIcon
              icon={faFileContract}
              size="xl"
              style={{ color: "#f2ce00" }}
            />
          </div> */}

            <div
              className={
                lang === "AR"
                  ? "ms-auto office_p-table-nav-btn"
                  : "me-auto office_p-table-nav-btn"
              }
              onClick={() => setRefreshData((prev) => prev + 1)}
            >
              <span>
                {dataTranslate.pages.office_p.table.table_head.refresh}
              </span>
              <FontAwesomeIcon
                icon={faArrowRotateRight}
                size="xl"
                style={{ color: "#f2ce00" }}
              />
            </div>

            <SearchBar
              lang={lang}
              search={search}
              handleSearch={handleSearch}
              options={searchOptions}
              setSearch={setSearch}
            />
          </Stack>
        </div>

        <div className="office_p-table-table w-100 m-3 px-3">
          <ConfirmModal
            show={confirmModal.isShow}
            onHide={() => setConfirmModal(initialConfirmModal)}
            post={changeUserStatus}
            data={confirmModal.rowData}
            lang={lang}
            dataTranslate={dataTranslate}
            setRefreshData={setRefreshData}
            action={confirmModal.blocked ? unblock_action : block_action}
            btnLoader={confirmBtnLoader}
            successMessage={successMessage}
            setSuccessMessage={setSuccessMessage}
          />

          {tableData ? (
            <DataTable
              lang={lang}
              columns={columns}
              dataTable={tableData}
              loader={loader}
              pageClass="office_p"
              search={search}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default UsersTable;
